// extracted by extract-css-chunks-webpack-plugin
module.exports = {"body":"Flm1tJPpkpRvpyvxnajR","bodyMargin":"HRDYr1jPo5gDkDfbomZr","links":"cVPidvx2VM7bpIxtgpfQ","submit":"BR9aOX_uASAXqQXh65rn","modalTerms":"qPS6NV1d5oyZkkcGdkbC"};